import styled from "styled-components";

export const MenuLinkItem = styled.a`
  &.active::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 5px;
    background: linear-gradient(224.14deg, #ffa600 -11.69%, #f36800 100%);
    bottom: 0;
  }
`;
